<div class="notification-dropdown-header">
  <h2>Notification</h2>
  <button mat-button>Mark all as read</button>
</div>
<div class="notification-dropdown-body">
  <!-- <ul>
    <li class="read">
      <a href="javascript:void()"
        >Lorem Ipsum is simply dummy text of the printing and typesetting
        industry</a
      >
    </li>
    <li>
      <a href="javascript:void()"
        >Lorem Ipsum is simply dummy text of the printing and typesetting
        industry</a
      >
    </li>
  </ul> -->
  <ul>
    <ng-template #noNotification>
      <div class="w-100 py-12 d-flex align-items-center justify-content-center">
        <p>No notification to show...</p>
      </div>
    </ng-template>
    <ng-container *ngIf="notifications.length > 0; else noNotification">
      <!-- <li
        class="position-relative cursor-pointer"
        *ngFor="let notification of notifications; index as i"
      >
        <div
          class="d-flex"
          (click)="
            removeNotification(i);
            markAsRead(
              notification.id,
              true,
              true,
              notification?.type,
              notification?.referenceId
            )
          "
        >
      <div class="notification-icon">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
              />
            </svg>
          </div>
          <div class="notification-body">
               <h6 class="notification-title" [innerHTML]="notification?.title"></h6>
            <span><i class="flaticon-timer"></i> {{ notification.time }}</span>
          </div>
        </div>
        <button
          class="close-btn bg-transparent border-none p-0"
          (click)="
            removeNotification(i); markAsRead(notification.id, true, false)
          "
        >
          <i class="flaticon-close"></i>
        </button>
      </li> -->
      <li
        class="notification-item"
        data-id="5"
        *ngFor="let notification of notifications; index as i"
      >
        <div class="notification-content" tabindex="0">
          <div class="notification-icon">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
              />
            </svg>
          </div>
          <div
            class="notification-body"
            (click)="
              removeNotification(i);
              markAsRead(
                notification.id,
                true,
                true,
                notification?.type,
                notification?.referenceId
              )
            "
          >
            <h6
              class="notification-title"
              [innerHTML]="notification?.title"
            ></h6>
            <div class="notification-meta">
              <svg
                class="icon-timer"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <span class="notification-time"> {{ notification.time }}</span>
            </div>
          </div>
        </div>
        <button
          class="notification-close-btn"
          aria-label="Dismiss notification"
          (click)="
            removeNotification(i); markAsRead(notification.id, true, false)
          "
        >
          <svg
            width="16"
            height="16"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </li>
    </ng-container>
  </ul>
</div>
<div class="notification-dropdown-footer">
  <button mat-button>View All</button>
</div>
